<template>
    <b-overlay :show="loading" rounded="sm" >
        <b-card :class="isCrm">
            <!-- Details Dialog -->
            <ReportsDialog ref="reportsDialog" :report-list="reportList" :query="reportQuery" title="Asset Reports" />
            <b-card-header class="assets-filter">
                <b-row class="mt-2">
                    <b-col cols="12" class="search-field">
                        <div class="input-group">
                            <b-form-input type="text" :placeholder="crm ? $translate('search_tasks') : $translate('search_assets')
                                " v-model="query"></b-form-input>
                            <div class="input-group-prepend bg-transparent"><i class="mdi mdi-magnify"></i></div>
                        </div>
                    </b-col>
                </b-row>
                <b-row class="mt-3">
                    <b-col cols="6">
                        <div class="d-flex">
                            <b-button variant="blue-button" class="me-2 d-flex"
                                @click="toggle_filters = !toggle_filters">
                                {{ $translate("filters") }}
                                <b-icon class="mt-1 ms-1" :icon="'chevron-' +
                                    (toggle_filters ? 'up' : 'down')
                                    " variant="dark"></b-icon>
                            </b-button>
                            <b-button variant="blue-button" @click="resetFilters" v-b-tooltip.hover
                                :title="$translate('reset_filters')">
                                <b-icon icon="arrow-repeat" variant="dark"></b-icon>
                            </b-button>
                        </div>
                    </b-col>
                    <b-col cols="6" class="p-0 pe-md-3 d-flex text-right align-items-center">
                        <slot></slot>
                    </b-col>
                </b-row>

                <asset-schedule-query-builder v-show="toggle_filters" v-model="filters" :types="types" :crm="crm" :officers="officers" :asset-frequencies="frequencies"
                    :roles="roles" :crm-setting-value="crmSettingValue" />
            </b-card-header>
            <b-card-body class="pt-0">
               
                <b-col class="page-block"><strong>{{ $translate('page') }}: {{ pagination.page }} {{ $translate('of') }} {{
                    pageCount }} {{ $translate('total') }}:
                        {{ pagination.total }}</strong></b-col>
                <b-col class="overflow-auto w-100 mt-4">
                    <b-table :fields="assetFields" striped hover responsive :items="assetSchedules">
                        <template>
                            <div class="text-center text-danger my-2">
                                <b-spinner class="align-middle"></b-spinner>
                                <!-- <strong>{{ $translate('loading') }}</strong> -->
                            </div>
                        </template>
                        <template #cell(actions)="row">
                            <b-button v-if="hasPermissionView" @click="viewAssetdata(row.item.asset_id)" class="me-2"
                                variant="pink-button">
                                <img src="@/assets/images/icon/view.svg" />
                            </b-button>
                        </template>
                        <template #cell(service_time_of_day)="{ value }">
                            <span> {{ IntToTimeFormat(value) }}</span>
                        </template>
                        <template #cell(frequency)="{ value }">
                            <span>{{ getFrequencyType(value) }}</span>
                        </template>
                    </b-table>
                </b-col>
                <b-row>
                    <b-col>
                        <b-pagination class="mt-4" v-model="pagination.page" :total-rows="pagination.total"
                            :per-page="pagination.pageSize" aria-controls="customerTable" :prev-text="$translate('previous')"
                            :next-text="$translate('next')" pills align="center"></b-pagination>
                    </b-col>
                </b-row>
            </b-card-body>
        </b-card>
    </b-overlay>
</template>

<script>
import _ from 'lodash'
import popupMixins from '@/mixins/popupMixins'
import assetMixins from '@/mixins/assetMixins'
import AssetScheduleQueryBuilder from './AssetScheduleQueryBuilder'
import ReportsDialog from '@/components/ReportsDialog'
import permissionsMixins from '@/mixins/permissionsMixins'
import { templates } from '@/exports/jsreport_templates'

export default {
    name: 'assets-itemList',
    components: { AssetScheduleQueryBuilder, ReportsDialog },
    props: [
        'type',
       
        'title',
        'crm',
        'crmSettingValue',
        'officers',
        'roles',
        'types',
    ],
    mixins: [popupMixins, permissionsMixins, assetMixins],
    data() {
        return {
            query: '',
            toggle_filters: false,
            loading: false,
            filters: {
                customer_id: null,
                type_id: null,
                default_engineer_id: null,
                role_id: null,
                next_service_from: null,
                next_service_to: null,
                last_service_from: null,
                last_service_to: null,
                warranty_from: null,
                warranty_to: null,
                frequency: null,
            },
        }
    },

    mounted() {
        if (this.$route.query.query) this.query = this.$route.query.query
        this.doSearch()
    },
    computed: {
        isCrm() {
            return this.$route.name.slice(0, 3) == 'crm' ? 'crm-listing' : 'asset-listing'
        },
        reportList() {
            return [
                {
                    id: 'asset_details',
                    value: templates.RPT_SVR_AST_DET_TEMPLATE,
                    extension: 'xlsx',
                    name: 'Asset Service History',
                    label: this.$translate('asset_service_history'),
                },
                {
                    id: 'asset_header',
                    value: templates.RPT_SVR_AST_HED_TEMPLATE,
                    extension: 'xlsx',
                    name: 'Asset Summary Report',
                    label: this.$translate('asset_summary_report'),
                },
                {
                    id: 'asset_listing',
                    value: templates.RPT_SVR_ASSLISXLS_TEMPLATE,
                    extension: 'xlsx',
                    name: 'Asset Listing Report',
                    label: this.$translate('asset_listing_report'),
                },
                {
                    id: 'asset_service',
                    value: templates.RPT_SVR_ASSSERNEW_TEMPLATE,
                    extension: 'xlsx',
                    name: 'Asset Service Report New Version',
                    label: this.$translate('asset_service_report_new_version')
                },
                {
                    id: 'asset_service_pdf',
                    value: templates.RPT_SVR_ASSSERNEWPDF_TEMPLATE,
                    extension: 'pdf',
                    name: 'Asset Service Report PDF',
                    label: this.$translate('asset_service_report_pdf')
                },
                {
                    id: 'crm_report',
                    value: templates.RPT_SVR_CRM_TEMPLATE,
                    extension: 'xlsx',
                    name: 'Asset Activities',
                    label: this.$translate('asset_activities')

                },
            ]
        },
        reportQuery() {
            const { query } = this
            return { query, ...this.filters }
        },
        pageCount() {
            return Math.ceil(this.pagination.total / this.pagination.pageSize);
        },
        pagination() {
            return this.$store.state.assetScheduleStore.assets_pagination || { page: 1 };
        },
        user() {
            return this.$store.state.user
        },

        assetFields() {
            

            const crmFields = [
                {
                  key: 'actions',
                  label: this.$translate('actions'),
                  class: 'actionButton_class',
              },
              {
                  key: 'asset_name',
                  label: this.$translate('name'),
                 
              },
              {
                  key: 'name',
                  label: this.$translate('schedule_name'),
                 
              },
              {
                  key: 'customer_name',
                  label: this.$translate('customer_name'),
                 
              },
              {
                  key: 'last_service_date',
                  label: this.$translate('last_visit'),
                 
              },
              {
                  key: 'next_service_date',
                  label: this.$translate('next_visit'),
                 
              },
              {
                  key: 'frequency',
                  label: this.$translate('frequency'),
                  
              },
            
           
             

             
             
              {
                  key: 'service_day_of_week',
                  label: this.$translate('service_week_day'),
                  formatter: (value) => this.formatDayOfWeek(value),
                 
              },
              {
                  key: 'service_time_of_day',
                  label: this.$translate('service_time_of_day'),
                 
              },
              {
                  key: 'termination_date',
                  label: this.$translate('termination_date'),
                 
              },
              {
                  key: 'agent_name',
                  label: this.$translate('officer'),
                
                 
              },
              {
                  key: 'type_name',
                  label: this.$translate('type'),
                 
              },
            
            ]
            if (this.crm) return crmFields
            return [
              
              {
                  key: 'actions',
                  label: this.$translate('actions'),
                  class: 'actionButton_class',
              },
              {
                  key: 'asset_name',
                  label: this.$translate('asset_name'),
                 
              },
              {
                  key: 'asset_sr_no',
                  label: this.$translate('model_no'),
                 
              },
              {
                  key: 'asset_model_no',
                  label: this.$translate('serial_no'),
                 
              },
              {
                  key: 'customer_name',
                  label: this.$translate('customer_name'),
                 
              },
              {
                  key: 'agent_name',
                  label: this.$translate('agent'),
                
                 
              },
              {
                  key: 'type_name',
                  label: this.$translate('type'),
                 
              },
              {
                  key: 'name',
                  label: this.$translate('schedule_name'),
                 
              },

              {
                  key: 'frequency',
                  label: this.$translate('frequency'),
                  
              },
              {
                  key: 'last_service_date',
                  label: this.$translate('last_service_date'),
                 
              },
              {
                  key: 'next_service_date',
                  label: this.$translate('next_service_date'),
                 
              },
              {
                  key: 'service_day_of_week',
                  label: this.$translate('service_week_day'),
                  formatter: (value) => this.formatDayOfWeek(value),
                 
              },
              {
                  key: 'service_time_of_day',
                  label: this.$translate('service_time_of_day'),
                 
              },
              {
                  key: 'termination_date',
                  label: this.$translate('termination_date'),
                 
              },
              
          ]
        },
        assetSchedules() {
            console.log('data----------', this.$store.state.assetScheduleStore.asset_schedules_all)
            return this.$store.state.assetScheduleStore.asset_schedules_all
        },
      
        
    },

    watch: {
        'crmSettingValue.type_id': function (type_id) {
            console.log('type_id----',type_id);
            if (this.crm) this.$set(this.filters, 'type_id', type_id || null)
        },
        'pagination.page': function (newPage) {
            this.changePage(newPage)
        },
        filters: {
            handler: function () {
               this.pureSearch()
            },
            deep: true,
        },
        query: function (query) {
            this.$router.push({ query: { query } })
            this.doSearch()
        },
    },

    methods: {
        getCrmQuery() {
            return this.reportQuery;
        },
        async  viewAssetdata(id) {
            if(this.crm){
              
            const { type_id } = this.crmSettingValue;
            console.log('type_id_is',type_id);
            await this.$store.dispatch('assets/get',id);
            await this.$store.dispatch('assetScheduleStore/fetchAssetSchedules', {id,type_id});
            const path = `/ams/crm/${id}`;
            if (path !== this.$route.path) {
                console.log('path', path);
                this.$router.push({ path });
            }
         

            }else{
            await this.$store.dispatch('assets/get',id);
            await this.$store.dispatch('assetScheduleStore/fetchAssetSchedules', id);
            const path = `/ams/assets/${id}`;
            if (path !== this.$route.path) {
                console.log('path', path);
                this.$router.push({ path });
            }
            this.$emit('change-tabIdx', 0);
            }
           
           
        },

        resetFilters() {
            this.filters = {
                customer_id: null,
                type_id: null,
                default_engineer_id: null,
                role_id: null,
                next_service_from: null,
                next_service_to: null,
                last_service_from: null,
                last_service_to: null,
                warranty_from: null,
                warranty_to: null,
                frequency: null,
            }
            this.doSearch()
        },
        changePage(page) {
            this.$router.push({ query: { page } })
            this.doSearch()
        },
        doSearch: _.debounce(async function () {
            await this.pureSearch()
        }, 500),
        async pureSearch() {
            try {
                this.loading = true
                const {
                    query,
                    pagination: { page },
                    filters,
                    crm,
                    crmSettingValue: { type_id },
                } = this

                if (crm) {
                 
                    this.$set(filters, 'type_id', type_id || null)
                    this.$set(filters, 'warranty_from', null)
                    this.$set(filters, 'warranty_to', null)
                } 

                // this.$set(filters, 'crm_type_id', type_id || null)

                await this.$store.dispatch('assetScheduleStore/fetch_all_schedules', {
                    query,
                    page,
                    filters,
                    crm
                })
            } catch (err) {
                console.error('loading error', err)
            } finally {
                this.loading = false
            }
        },
        showDetailsDialog() {
            this.$refs.reportsDialog.show()
        },
        getFrequencyType(value) {
            const { frequencies } =
                this.$store.getters['company/assetFrequencies']
            const obj = (frequencies || []).find(x => x.value == value)
            return obj ? obj.name : value == '0' ? 'One Off' : ''
        },
        
        formatDayOfWeek(value) {
        
        const daysOfWeek = [
            'Sunday',    // Index 1: Sunday
            'Monday',    // Index 2: Monday
            'Tuesday',   // Index 3: Tuesday
            'Wednesday', // Index 4: Wednesday
            'Thursday',  // Index 5: Thursday
            'Friday',    // Index 6: Friday
            'Saturday'   // Index 7: Saturday
        ];

       
        return daysOfWeek[value] || '';
    },

    IntToTimeFormat(intValue) {
            const formatInt = (_int) => {
                if (_int < 10) _int = `0${_int}`;
                else _int = _int.toString();
                return _int;
            };
            let hours = parseInt(intValue / 60, 10);
            if (hours > 23 || hours < 0) hours = 0;
            let minutes = intValue - hours * 60;

            return `${formatInt(hours)}:${formatInt(minutes)}`;
        },
    },
}
</script>
<style></style>
